module.exports = __webpack_public_path__ + "img/Graggle.1a078647.png";